import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge7 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権とは' fontWeight={700} />
                <p>
                    会員制のゴルフクラブには、大別すると預託金会員制と株主会員制の２種類があります。
                    <br />
                    どちらのゴルフクラブでも、会員になるとゴルフ場施設の優先的利用権が得られ、その証としてゴルフ会員権が付与されます。
                    <br />
                    その会員権は一部のゴルフクラブを除き、市場で自由に売買することが出来ます。
                    <br />
                    まずもう少し「預託金会員制」と「株主会員制」の違いなどを説明していきます。
                </p>

                <Heading3 title='預託金会員制' />
                <p>
                    会員権を購入する際に会員が一定の金額を預託金としてゴルフ場会社に預け、優先的施設利用権と預託金返還請求権を取得して会員となる制度です。
                    <br />
                    通常、預託金は無利子で一定期間据え置かれますが、期日がきた場合は退会と引き換えに預託金の返還を請求することが出来ます。
                    <br />
                    ただし返還に応じるかどうかはゴルフ場によって対応が異なります。ゴルフ俱楽部が経営破綻した場合は殆ど返還される事はありません。
                </p>

                <Heading3 title='株主会員制' />
                <p>
                    会員が入会時に株主として一定の金額を出資することで、ゴルフ場経営会社の株主となり施設利用権を取得する制度です。
                    <br />
                    クラブが解散となった時には、持株比率に応じて、クラブの残余財産を請求出来る権利があります。
                    <br />
                    株主としての権利行使や売買に関しては定款に定められた規定に従います。
                    <br />
                    冒頭でお伝えしたとおり、「預託金会員制」と「株主会員制」いずれも形態は違いますが、消費税の課税関係が異なることはありません。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の購入にまつわる消費税' fontWeight={700} />
                <p>
                    ゴルフ場会社が募集等で最初の会員に会員権を発行する場合において、その発行に対して受ける金銭は株式形態の場合は出資金であり、預託金形式の場合は預り金ですから、いずれも資産の譲渡等の対価に該当せず消費税の課税対象になりません。
                    <br />
                    ただし、募集時における返還されない入会金は課税対象となります。
                    <br />
                    <br />
                    一方、市場でゴルフ会員権を売買する場合は、資産の対価として受け取るゴルフ会員権代金と名義書換料も消費税の課税対象となります。
                    <br />
                    ゴルフ会員権業者がゴルフ会員権の所有者又は購入希望者からの委託を受けてゴルフ会員権の売買を行った場合、株式形態のものは株式の譲渡に、預託形態のものは金銭債権の譲渡にそれぞれ該当しますが、株式形態のものであっても消費税法上は有価証券とは扱われていないため、非課税とはならず、課税対象になります。
                    <br />
                    また、その売買に係る手数料も課税対象になります。
                    <br />
                    <br />
                    消費税を納税面からみると、事業者には原則として納税の義務があります。この事業者とは個人と法人（団体を含む）があり、同種の行為を反復、継続して行う者です。ただし、事業者にも課税事業者と納税の義務が免除される免税事業者があります。
                    <br />
                    <br />
                    具体的には課税売上高１０００万円以下の事業者が免税事業者にあたり、それ以外は課税事業者となります。
                    <br />
                    <br />
                    課税事業者は基準期間（個人事業者は前々年、法人は原則として前々事業年度）、または特定期間（個人事業者は前年の１月から６月まで、法人は原則として前年度の期首から６ヶ月の期間）の課税売上高で判定します。会社設立時など基準期間や特定期間が定められないときは、期首の資本金による判定をすることになります。期首の資本金が１０００万円未満であるときは免税事業者となり納税義務はありません。
                    <br />
                    <br />
                    課税事業者が会員権業者から会員権を購入した場合、その購入は課税仕入れとなります。ゴルフクラブが発行する会員権を事業者が直接取得する場合は課税仕入にはなりません。（返還を要しない入会金や名義変更料は除きます。）また、事業者が所有している会員権を譲渡した場合も課税の対象になります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権にまつわる譲渡（売却）・退会に際する消費税' fontWeight={700} />
                <p>
                    ゴルフ会員権の譲渡は課税取引として消費税が課せられます。ゴルフ会員権はよく有価証券と思われがちですが、消費税法上は有価証券ではないので非課税取引から除外されます。
                    <br />
                    ただし、個人が所有しているゴルフ会員権を売却するときで、単発的に会員権を譲渡する場合は、その行為は事業として認められないため課税取引であっても納税義務は生じません。
                    <br />
                    <br />
                    逆に消費税の納税義務が生じるのは、ゴルフ会員権の売買を事業として行っているとき、また法人の場合は原則としてすべての場合に納税義務が生じます。
                    <br />
                    <br />
                    預託金形式のゴルフ会員権は会員が退会を希望した場合には預託金が返還されることになっています。この預託金の返還は資産の譲渡性はありませんので課税対象外となります。
                    <br />
                    法人がゴルフ会員権を売却した時は、売却損が発生した場合であっても課税売上高として仕訳する必要があります。
                    <br />
                    ただし、売却代金を計上する時には、税込価格で計上する方法と税抜き価格で計上する方法の２通りがあり、消費税納税時の経理処理の仕方が変わってくるので注意が必要です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='当社のゴルフ会員権と取扱手数料は税込（内税）です' fontWeight={700} />
                <p>
                    住地ゴルフではゴルフ会員権価格及び取扱手数料ともに明快な税込（内税）で承っております。
                    <br />
                    ※もちろん名義書換料、年会費も税込で案内しております。
                    <br />
                    ご購入の場合は税別（外税）にして別途消費税分を頂戴することはありませんし、ご売却の場合には法人のお客様はもちろん、個人のお客様にも消費税分を含んだ価格でご案内いたします。
                    <br />
                    「相場確認」や「価格交渉」の際に、お客様ご自身で消費税分を加算する必要はありません。詳細は当社までお問合せください。
                    <br />
                    売却時の消費税の課否判定と法人・個人別の具体的な仕訳例については
                    <a href='/knowledge/33'>ゴルフ会員権売却時の消費税・仕訳（法人・個人別）</a>
                    で詳しくご紹介しています。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge7;
